import React, {useEffect} from 'react';

import SimpleCardContainer from "../ui/SimpleCardContainer";
import {useApi} from "../../providers/ApiProvider";
import AccountTypesModel from "../../models/AccountTypesModel";
import {useBreadcrumbs} from "../../providers/BreadcrumbsProvider";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../providers/TranslationProvider";
import {useAuth} from "../../providers/AuthProvider";
import {useParams} from "react-router-dom";
import ButtonWithLoading from "../layout/ui/ButtonWithLoading";
import {useNotifications} from "../../providers/NotificationsProvider";

export default function AccountTypeEdit(props) {
    const params = useParams();
    const {language} = useMyTranslation();
    const breadcrumbs = useBreadcrumbs();
    const apiContext = useApi();
    const accountTypesModel = new AccountTypesModel(apiContext.api);
    const { t} = useTranslation();
    const notificationsContext = useNotifications();

    const [loading, setLoading] = React.useState(false);
    const [errors, setErrors] = React.useState([]);
    const [formName, setFormName] = React.useState('');
    const [formMaxProfiles, setFormMaxProfiles] = React.useState(0);
    const [formOrder, setFormOrder] = React.useState(0);


    useEffect(() => {
        breadcrumbs.update({
            title: t('Edit account type information'),
            breadcrumbs: [
                {label: t('Account types'), url: '/account-types'},
                {label: t('Edit account type information')}
            ]
        });

        document.title = t('Edit account type information')+' | LocalBoost';

        accountTypesModel.view(params.accountTypeId).then((response) => {
            if (response !== false) {
                setFormName(response.name);
                setFormMaxProfiles(response.limits.max_profiles);
                setFormOrder(response.order);
            }
        });
    }, [language]);


    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        accountTypesModel.update(params.accountTypeId, {
            name: formName,
            max_profiles: formMaxProfiles,
            order: formOrder,
        }, onUpdateError).then((response) => {
            if (response !== false) {
                notificationsContext.notify(t('Account type updated successfully!'), 'success');
            }

            setLoading(false);
        });
    }


    const onUpdateError = (response) => {
        if (response && response.data) {
            setErrors(response.data);
        }

        setLoading(false);
    }


    return (
        <SimpleCardContainer title={t('Edit account type information')}>
            <form className={'py-2'}>
                <div className={'row'}>
                    <div className={'col-md-6'}>
                        <div className={'row'}>
                            <div className={'col-md-6'}>
                                <div className={'form-group'}>
                                    <label className="form-label fw-semibold mb-2">{t('Name')}</label>

                                    <input id={'cd-id'} className={'form-control'} value={formName} onChange={(e) => {
                                        setFormName(e.target.value)
                                    }}/>

                                    <div className="d-flex justify-content-between">
                                        {errors && errors.name && <div className="form-text text-danger">{errors.name.join(' ')}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'row'}>
                            <div className={'col-md-4'}>
                                <div className={'form-group mt-3'}>
                                    <label className="form-label fw-semibold mb-2">{t('Max Profiles')}</label>

                                    <input id={'cd-id'} className={'form-control'} value={formMaxProfiles} onChange={(e) => {
                                        setFormMaxProfiles(e.target.value)
                                    }}/>

                                    <div className="d-flex justify-content-between">
                                        {errors && errors.max_profiles && <div className="form-text text-danger">{errors.max_profiles.join(' ')}</div>}
                                    </div>
                                </div>
                            </div>
                            <div className={'col-md-4'}>
                                <div className={'form-group mt-3'}>
                                    <label className="form-label fw-semibold mb-2">{t('Sorting Order')}</label>

                                    <input id={'cd-id'} className={'form-control'} value={formOrder} onChange={(e) => {
                                        setFormOrder(e.target.value)
                                    }}/>

                                    <div className="d-flex justify-content-between">
                                        {errors && errors.order && <div className="form-text text-danger">{errors.order.join(' ')}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="bordered-tip pb-4">
                            <div className="alert alert-info" role="alert">
                                <strong>{t('Pro Tip!')}</strong>
                                <span
                                    className="d-block fs-2 mt-2">{t('Please, for ID use only letters, digits, "_" and "-". For example: ')}<em>10_profiles</em>.</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'form-group mt-4'}>
                    <ButtonWithLoading
                        className={'btn-primary'}
                        label={t('Save changes')}
                        loading={loading}
                        onClick={onSubmit}
                    />
                </div>
            </form>
        </SimpleCardContainer>
    );
}
